module.exports = __webpack_public_path__ + "fa79a1452f77939527e8a905e0d85c6f.MP3";